'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (target) {
  target.prototype.isCapture = function (currentTarget) {
    var dataIsCapture = currentTarget.getAttribute('data-iscapture');
    return dataIsCapture && dataIsCapture === 'true' || this.props.isCapture || false;
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/react-tooltip/dist/decorators/isCapture.js
// module id = 1338
// module chunks = 0